import React from 'react'
import PageHeader from '../common/page-header'
import TermsConditionsContent from './content'

const TermsConds = () => (
  <>
    <PageHeader title="Terms &amp; Conditions" />
    <TermsConditionsContent />
  </>
)
export default TermsConds
